import { BlueprintUnassignedWarningIgnoreButtonWrapper } from "@src/components/molecules/blueprint-unassigned-warning-ignore-button-wrapper/blueprint-unassigned-warning-ignore-button-wrapper";
import React from "react";
import { ourNodeRenderDataAcquisitionTypeWrapper } from "./our-node-render-data-acquisition-type-wrapper";

export const manageUnassignedOurNodeViewInBlueprintMode = (child, type) => {
  if (type !== "machine") return;
  if (!child.unassigned) {
    return <>{ourNodeRenderDataAcquisitionTypeWrapper(child, type)}</>;
  } else {
    return <BlueprintUnassignedWarningIgnoreButtonWrapper />;
  }
};
